/**
 * Taken from this link
 * https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/
 * */

export function localStorageAdapter(storageName = "vidio_default") {
  function localStoreName() {
    return `local_storage_${storageName}`;
  }

  function isSupported() {
    if (!window[localStoreName()]) {
      window[localStoreName()] = {};
    }

    try {
      const testKey = "adapter-check-new";
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  function clear() {
    if (isSupported()) {
      localStorage.clear();
    } else {
      window[localStoreName()] = {};
    }
  }

  function getItem(name) {
    /* eslint-disable no-prototype-builtins */
    if (isSupported()) {
      return localStorage.getItem(name);
    }
    if (window[localStoreName()].hasOwnProperty(name)) {
      return window[localStoreName()][name];
    }
    return null;
  }

  function key(index) {
    if (isSupported()) {
      return localStorage.key(index);
    } else {
      return Object.keys(window[localStoreName()])[index] || null;
    }
  }

  function removeItem(name) {
    if (isSupported()) {
      localStorage.removeItem(name);
    } else {
      delete window[localStoreName()][name];
    }
  }

  function setItem(name, value = "") {
    if (isSupported()) {
      localStorage.setItem(name, value);
    } else {
      window[localStoreName()][name] = String(value); // not everyone uses TypeScript
    }
  }

  function length() {
    if (isSupported()) {
      return localStorage.length;
    } else {
      return Object.keys(window[localStoreName()]).length;
    }
  }

  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key,
    get length() {
      return length();
    },
  };
}
